export enum SrsBallotReviewStage {
    ReadyForReviewSubmission = 1,
    SrtReview = 2,
    SdApproverReview = 3,
    PgmReview = 4,
    RegulatorReview = 5,
    SnzReview = 6,
    ReviewComplete = 7
}